import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  dialog: {
    '& .MuiDialog-paper': {
      height: '100%'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    p: 0,
    overflow: 'hidden'
  },
  tabsContainer: {
    borderBottom: 1,
    borderColor: 'divider',
    bgcolor: 'background.paper'
  },
  tab: {
    minHeight: 48,
    textTransform: 'none',
    fontWeight: 500,
    '&.Mui-selected': {
      color: 'primary.main',
      bgcolor: 'primary.lighter',
      borderRadius: 1
    }
  },
  tabContent: {
    p: 2,
    flexGrow: 1,
    minHeight: 0,
    overflow: 'auto'
  }
};